import { Component } from '@mycolorway/tao';
import { MDCMenuSurface } from '@material/menu-surface';
import { closest } from 'next/javascripts/modules/dom';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/form-fields/color-select-field';

Component('tr-color-select-field', {
  mixins: [eventListenerMixin],

  properties: {
    appendMenuToBody: {
      type: Boolean,
      default: false,
    },
  },

  connected() {
    this.nativeField = this.querySelector('input[type="hidden"]');
    this.resultBox = this.querySelector('.color-select-result .result-box');
    this.colorSelect = this.querySelector('.color-select');
    this.menuSurface = this.querySelector('.mdc-menu-surface');
    this.mdcMenuSurface = new MDCMenuSurface(this.menuSurface);
    if (this.appendMenuToBody) this.mdcMenuSurface.hoistMenuToBody();

    this.addEventListeners();
    this.initialSelected();
  },

  disconnnected() {
    this.stopListening();
    if (this.mdcMenuSurface) this.mdcMenuSurface.destroy();
  },

  addEventListeners() {
    this.listenTo(this.resultBox, 'click', this.handleClick.bind(this));
    this.listenTo(this.colorSelect, 'click', this.handleColorOptionClick.bind(this));
  },

  initialSelected() {
    this.selectedOption = this.colorSelect.querySelector('.color-option.selected');
    this.setSelectedResult();
  },

  setSelectedResult() {
    if (!this.selectedOption) return;

    const { backgroundColor, borderColor } = this.selectedOption.style;
    this.resultBox.style.backgroundColor = backgroundColor;
    this.resultBox.style.borderColor = borderColor;
    this.resultBox.dataset.color = this.selectedOption.dataset.value;
  },

  handleClick() {
    this.mdcMenuSurface.open = !this.mdcMenuSurface.open;
  },

  handleColorOptionClick(event) {
    event.stopPropagation();

    const option = closest(event.target, '.color-option');
    this.selectColor(option);
  },

  selectColor(color) {
    let option = color;
    if (typeof option === 'string') {
      option = this.menuSurface.querySelector(`.color-option[data-value=${option}]`);
    }
    if (!option) return;

    if (this.selectedOption) {
      if (this.selectedOption.isSameNode(option)) return;
      this.selectedOption.classList.remove('selected');
    }

    option.classList.add('selected');
    this.selectedOption = option;

    this.nativeField.value = option.getAttribute('data-value');
    this.setSelectedResult();
  },

  get value() {
    if (this.selectedOption) {
      return this.selectedOption.dataset.value;
    }
    return null;
  },
});
